class APIHelper {
  static INVALID_CREDENTIALS_ERROR_MESSAGE = 'Invalid credentials';
  static UNAUTHORIZED_STATUS_CODE = 401;

  constructor(endpoint) {
    this.endpointUrl = `${process.env.REACT_APP_API_URL}${endpoint}`;
  }

  async doPost(body, headers) {
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
      body: JSON.stringify(body),
    };

    const response = await fetch(this.endpointUrl, options);
    await this.checkResponse(response);
    return await response.json();
  }

  async checkResponse(response) {
    if (!response.ok) {
      const error = await response.json();
      if (
        error.message.includes(APIHelper.INVALID_CREDENTIALS_ERROR_MESSAGE) ||
        response.status === APIHelper.UNAUTHORIZED_STATUS_CODE
      ) {
        throw new Error('Invalid credentials');
      }

      throw new Error(
        `API call failed with status: ${response.status}\n${error.message}`
      );
    }
  }
}

export default APIHelper;
